import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { PhotoStep } from '@transpordiamet/shared';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get localized field value from a PhotoStep object
 * @param step - PhotoStep object containing translated fields
 * @param field - Base field name ('title' or 'description')
 * @param locale - Current locale ('en', 'et', 'ru')
 * @returns Localized field value with fallback to English
 */
export function getLocalizedStepField(step: PhotoStep, field: 'title' | 'description', locale: string): string {
  const key = `${field}_${locale}` as keyof PhotoStep;
  const fallbackKey = `${field}_en` as keyof PhotoStep;

  // Try locale-specific field, fall back to English
  return (step[key] as string) || (step[fallbackKey] as string) || '';
}

/**
 * Add language query parameter to a path
 * @param path - The path to navigate to
 * @param searchParams - URLSearchParams object containing current query params
 * @returns Path with language query parameter preserved
 */
export function addLangParam(path: string, searchParams: URLSearchParams): string {
  const lang = searchParams.get('lang');
  if (!lang) return path;

  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}lang=${lang}`;
}
